import { Box } from '@mui/material';
import React from 'react';

interface LabelProps {
  text: string;
  backgroundColor: string;
  color: string;
  margin?: string
}

const Label = ({ text, backgroundColor, color, margin }: LabelProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        fontSize: '12px',
        fontWeight: '600',
        lineSpacing: '0.5px',
        margin,
        padding: '4px 8px',
        width: 'max-content',
        alignItems: 'flex-start',
        borderRadius: '100px',
        backgroundColor,
        color,
      }}
    >
      {text}
    </Box>
  );
};

export default Label;
